import request from '@/utils/request'
/* 获取商品列表接口 */
export function getGoodsAll(data) {
  return request({
    url: '/admin/goods/page',
    method: 'get',
	  params:data
  })
}

/* 获取供应商列表接口 */
export function getSuppliersAll(data) {
  return request({
    url: '/admin/suppliers/all',
    method: 'get',
	  params:data
  })
}

export function getGoodsDetail(data){
	return request({
	  url: '/admin/goods/detail',
	  method: 'get',
			params:data
	})
}

export function goodsup(data) {
  return request({
    url: `/admin/goods/${data.id}`,
    method: 'put',
    data,
  })
}

//商品上下架
export function goodsGrounding(data) {
  return request({
    url: `/admin/goods/${data.id}/grounding/`,
    method: 'post',
    data,
  })
}

